/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStopwatch: {
  name: 'stopwatch';
  data: string;
} = {
  name: 'stopwatch',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1ZM6 13a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-8a8 8 0 1 0 6.32 3.094l1.387-1.387a1 1 0 0 0-1.414-1.414L16.906 6.68A7.965 7.965 0 0 0 12 5Zm0 6a1 1 0 1 0-2 0v2a2 2 0 0 0 2 2h2a1 1 0 1 0 0-2h-2v-2Z" fill="currentColor"/></svg>`,
};
